import {
  createApiFactory,
  createApiRef,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { HttpReleaseCalendarClient } from './api/HttpReleaseCalendarClient';
import type { ReleaseCalendarApi } from './api/types';
import { rootRouteRef } from './routes';

export const releaseCalendarApiRef = createApiRef<ReleaseCalendarApi>({
  id: 'plugin.release-calendar.service',
});

export const releaseCalendarPlugin = createPlugin({
  id: 'release-calendar',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: releaseCalendarApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new HttpReleaseCalendarClient(discoveryApi, fetchApi),
    }),
  ],
});

/**
 * The main Release Calendar page component.
 *
 * Add to your Backstage app:
 * ```tsx
 * <Route path="/release-calendar" element={<ReleaseCalendarPage />} />
 * ```
 */
export const ReleaseCalendarPage = releaseCalendarPlugin.provide(
  createRoutableExtension({
    name: 'ReleaseCalendarPage',
    component: () =>
      import('./components/ReleaseCalendarPage').then(
        m => m.ReleaseCalendarPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
